/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Session_Time_Short_EveningInputs */

const vi_stocktake_session_time_short_evening = /** @type {(inputs: Stocktake_Session_Time_Short_EveningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiều`)
};

/**

* @param {Stocktake_Session_Time_Short_EveningInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_session_time_short_evening = /** @type {((inputs?: Stocktake_Session_Time_Short_EveningInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Session_Time_Short_EveningInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_session_time_short_evening(inputs)
});